import {
  sovReqToken,
  VNCookie,
  ClickWorkToken,
  ClickWorkCookie,
  EverflowToken,
  EverflowCookie,
  OrangeBuddiesCookie,
  OrangeBuddiesToken,
  EverflowClientCookie,
  EverflowClientToken,
  UTMCampaignToken,
  UTMCampaignCookie,
  UTMMediumToken,
  UTMMediumCookie,
  UTMSourceToken,
  UTMSourceCookie,
  SnapchatClickIdToken,
  SnapchatClickIdCookie,
  FacebookClickIdToken,
  FacebookClickIdCookie,
  CookieDuration,
  LandingPageUrlCookie,
  PromotionCodeCookie,
  FeatureTestCookie,
  EverflowClientOfferIDToken,
  EverflowClientAffiliateIDToken,
  EverflowClientAdditionalParametersCookie,
  McanismToken,
  McanismCookie,
  OTANoCampaignCookie,
  Media4MomentsToken,
  Media4MomentsCookie,
  AdtractionToken,
  AdtractionCookie,
  ManualABTestingCookie,
  ManualABTestingCookieTwo,
  ManualABTestingCookieThree,
  SpaazaReferralCodeToken,
  SpaazaReferralCodeCookie
} from '@/enums/gtm'
import { getCookieDomain } from '@/utils/cookie'
import { PaymentFeatureFlagCookieQuery } from '@/enums/payments'
import { compareFbclid, formatFbclid } from '@/utils/tracking'
import { serializeParameters } from '@/utils/general'
import { getRandomVariant } from '@/utils/gtm'
import { defineNuxtRouteMiddleware, useCookie } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to) => {
  const sovendusToken = to.query[sovReqToken]
  const vnToken = to.query[VNCookie]
  const cbToken = to.query[ClickWorkToken]
  const efToken = to.query[EverflowToken]
  const obToken = to.query[OrangeBuddiesToken]
  const efcToken = to.query[EverflowClientToken]
  const fbClickId = to.query[FacebookClickIdToken]
  const utmSource = to.query[UTMSourceToken]
  const utmMedium = to.query[UTMMediumToken]
  const utmCampaign = to.query[UTMCampaignToken]
  const promotionCode = to.query.code
  const noCampaign = to.query.nocam
  const featureTest = to.query[FeatureTestCookie]
  const mcanismClickId = to.query[McanismToken]
  const media4Moments = to.query[Media4MomentsToken]
  const adtraction = to.query[AdtractionToken]
  const spaazaReferralCode = to.query[SpaazaReferralCodeToken]
  const hasPaymentFeatureFlagQuery = Object.prototype.hasOwnProperty.call(to.query, PaymentFeatureFlagCookieQuery)

  const variant = getRandomVariant(4)

  if (useCookie(ManualABTestingCookie).value === undefined) {
    const cookie = useCookie(ManualABTestingCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = `${variant}`
  }

  const variantTwo = getRandomVariant(4)

  if (useCookie(ManualABTestingCookieTwo).value === undefined) {
    const cookie = useCookie(ManualABTestingCookieTwo, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = `${variantTwo}`
  }

  const variantThree = getRandomVariant(20)

  if (useCookie(ManualABTestingCookieThree).value === undefined) {
    const cookie = useCookie(ManualABTestingCookieThree, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = `${variantThree}`
  }

  if (hasPaymentFeatureFlagQuery) {
    const cookie = useCookie(PaymentFeatureFlagCookieQuery, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = 'true'
  }

  if (sovendusToken) {
    const cookie = useCookie(sovReqToken, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(sovendusToken)
  }

  if (vnToken) {
    const cookie = useCookie(VNCookie, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
    cookie.value = String(vnToken)
  }

  if (spaazaReferralCode) {
    const cookie = useCookie(SpaazaReferralCodeCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(spaazaReferralCode)
  }

  if (cbToken) {
    const cookie = useCookie(ClickWorkCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(cbToken)
  }

  if (efToken) {
    const cookie = useCookie(EverflowCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(efToken)
  }

  if (obToken) {
    const cookie = useCookie(OrangeBuddiesCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(obToken)
  }

  if (efcToken) {
    const cookie = useCookie(EverflowClientCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(efcToken)
  }

  if (featureTest) {
    const cookie = useCookie(FeatureTestCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(featureTest)
  }

  if (fbClickId) {
    const oldCookie = useCookie(FacebookClickIdCookie)
    const oldFbclid = oldCookie.value

    if (!oldFbclid || !compareFbclid(fbClickId, oldFbclid)) {
      const newFbclid = formatFbclid(`${fbClickId}`)
      const cookie = useCookie(FacebookClickIdCookie, {
        expires: new Date(Date.now() + CookieDuration),
        path: '/',
        domain: getCookieDomain()
      })
      cookie.value = newFbclid
    }
  }

  if (to.query[SnapchatClickIdToken]) {
    const cookie = useCookie(SnapchatClickIdCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(to.query[SnapchatClickIdToken])
  }

  if (utmSource) {
    const cookie = useCookie(UTMSourceCookie, { path: '/', domain: getCookieDomain() })
    cookie.value = String(utmSource)
  }

  if (utmMedium) {
    const cookie = useCookie(UTMMediumCookie, { path: '/', domain: getCookieDomain() })
    cookie.value = String(utmMedium)
  }

  if (mcanismClickId) {
    const cookie = useCookie(McanismCookie, { expires: new Date(Date.now() + 86400000), path: '/', domain: getCookieDomain() })
    cookie.value = String(mcanismClickId)
  }

  if (media4Moments) {
    const cookie = useCookie(Media4MomentsCookie, {
      expires: new Date(Date.now() + 86400000),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(media4Moments)
  }

  if (adtraction) {
    const cookie = useCookie(AdtractionCookie, { expires: new Date(Date.now() + 86400000), path: '/', domain: getCookieDomain() })
    cookie.value = String(adtraction)
  }

  if (noCampaign) {
    const cookie = useCookie(OTANoCampaignCookie, { path: '/', domain: getCookieDomain() })
    cookie.value = String(noCampaign)
  }

  if (utmCampaign) {
    const cookie = useCookie(UTMCampaignCookie, { path: '/', domain: getCookieDomain() })
    cookie.value = String(utmCampaign)
  }

  if (to.fullPath && import.meta.server && !to.fullPath.includes('signup/create-account/verification-payment/')) {
    const cookie = useCookie(LandingPageUrlCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = to.fullPath
  }

  if (promotionCode) {
    const cookie = useCookie(PromotionCodeCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = String(promotionCode)
  }

  const everflowAdditionalParams = {
    adv_event_id: to.query.adv_event_id,
    oid: to.query[EverflowClientOfferIDToken],
    affid: to.query[EverflowClientAffiliateIDToken],
    source_id: to.query.source_id,
    sub1: to.query.sub1,
    sub2: to.query.sub2,
    sub3: to.query.sub3,
    sub4: to.query.sub4,
    sub5: to.query.sub5
  }

  const additionalParams = serializeParameters(everflowAdditionalParams)
  const hasAtLeastOneValue = Object.values(everflowAdditionalParams).some(
    (value) => value !== undefined && value !== null && value !== ''
  )

  if (additionalParams && hasAtLeastOneValue) {
    const cookie = useCookie(EverflowClientAdditionalParametersCookie, {
      expires: new Date(Date.now() + CookieDuration),
      path: '/',
      domain: getCookieDomain()
    })
    cookie.value = additionalParams
  }
})
